import {
    Card,
    CardContent,
    Typography,
} from '@mui/material'
import EditLocationTable from './EditLocationTable'
import { useContext, useEffect, useState } from 'react'
import { Context } from '../../context/context'

import { Trans } from 'react-i18next'
import api from '../../api'

function EditLocationPage() {
    const [{ user },] = useContext(Context);
    const [locations, setLocations] = useState([])
    useEffect(() => {
        if (user.id !== '') {
            api.readInstitute(user.institute).then(res => {
                setLocations(res.locations);
            });
        };
    }, [user]);

    const updateLocation = (location) => {
        api.updateLocation(location.id, location).then(res => {
            api.readInstitute(user.institute).then(res => {
                setLocations([...res.locations]);
            });
        });
    };

    const createLocation = (name) => {
        let location = {
            name: name,
            holidays: [],
            closingDays: [],
        };

        api.createInstituteLocation(user.institute, location).then(res => {
            api.readInstitute(user.institute).then(res => {
                setLocations(res.locations);
            });
        });
    };

    const setDefaultLocation = (locationId) => {
        api.updateInstituteDefaultLocation(user.institute, locationId).then(res => {
            api.readInstitute(user.institute).then(res => {
                setLocations(res.locations);
            });
        });
    };

    const deleteLocation = (locationId) => {
        api.deleteLocation(locationId).then(res => {
            api.readInstitute(user.institute).then(res => {
                setLocations(res.locations);
            });
        });
    };

    return (
        <>
            <Card sx={{ width: '100vw', p: 3 }}>
                <CardContent>
                    <Typography variant="h5"><Trans i18nKey="institutsstandorte" ns="instituteConfigurationPage">Institutsstandorte</Trans></Typography>
                    <EditLocationTable
                        locations={locations}
                        onUpdate={updateLocation}
                        onDelete={deleteLocation}
                        onMakeDefault={setDefaultLocation}
                        onCreate={createLocation}
                    />
                </CardContent>
            </Card>
        </>
    )
}

export default EditLocationPage
